/* tslint:disable */
/* eslint-disable */
/**
 * Docusign API
 * Docusign is a service that allows the user to send the documents for signing
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DateSignedTab } from './DateSignedTab';
import {
    DateSignedTabFromJSON,
    DateSignedTabFromJSONTyped,
    DateSignedTabToJSON,
} from './DateSignedTab';
import type { FullNameTab } from './FullNameTab';
import {
    FullNameTabFromJSON,
    FullNameTabFromJSONTyped,
    FullNameTabToJSON,
} from './FullNameTab';
import type { SignHereTab } from './SignHereTab';
import {
    SignHereTabFromJSON,
    SignHereTabFromJSONTyped,
    SignHereTabToJSON,
} from './SignHereTab';
import type { TextTab } from './TextTab';
import {
    TextTabFromJSON,
    TextTabFromJSONTyped,
    TextTabToJSON,
} from './TextTab';

/**
 * 
 * @export
 * @interface Tabs
 */
export interface Tabs {
    /**
     * FullNameTab for the signer
     * @type {Array<FullNameTab>}
     * @memberof Tabs
     */
    fullNameTabs: Array<FullNameTab>;
    /**
     * DateSignedTab for the signer
     * @type {Array<DateSignedTab>}
     * @memberof Tabs
     */
    dateSignedTabs: Array<DateSignedTab>;
    /**
     * SignHereTab for the signer
     * @type {Array<SignHereTab>}
     * @memberof Tabs
     */
    signHereTabs: Array<SignHereTab>;
    /**
     * TextTab for the signer
     * @type {Array<TextTab>}
     * @memberof Tabs
     */
    textTabs: Array<TextTab>;
}

/**
 * Check if a given object implements the Tabs interface.
 */
export function instanceOfTabs(value: object): boolean {
    if (!('fullNameTabs' in value)) return false;
    if (!('dateSignedTabs' in value)) return false;
    if (!('signHereTabs' in value)) return false;
    if (!('textTabs' in value)) return false;
    return true;
}

export function TabsFromJSON(json: any): Tabs {
    return TabsFromJSONTyped(json, false);
}

export function TabsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Tabs {
    if (json == null) {
        return json;
    }
    return {
        
        'fullNameTabs': ((json['fullNameTabs'] as Array<any>).map(FullNameTabFromJSON)),
        'dateSignedTabs': ((json['dateSignedTabs'] as Array<any>).map(DateSignedTabFromJSON)),
        'signHereTabs': ((json['signHereTabs'] as Array<any>).map(SignHereTabFromJSON)),
        'textTabs': ((json['textTabs'] as Array<any>).map(TextTabFromJSON)),
    };
}

export function TabsToJSON(value?: Tabs | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fullNameTabs': ((value['fullNameTabs'] as Array<any>).map(FullNameTabToJSON)),
        'dateSignedTabs': ((value['dateSignedTabs'] as Array<any>).map(DateSignedTabToJSON)),
        'signHereTabs': ((value['signHereTabs'] as Array<any>).map(SignHereTabToJSON)),
        'textTabs': ((value['textTabs'] as Array<any>).map(TextTabToJSON)),
    };
}

